module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloud-haze-1-fa07a87b.svg";